<template lang="pug">
  .menu(v-if="content" :class="{'menu--menu-open': leftMenuOpen}")
    .page__wr
      .menu__bread
        Bread(v-if="content.bread", :bread="content.bread")
      .menu__wr
        .menu__leftBlock
          .menu__catalog.js-mobile-menu-left(v-if="content.nav")
            .menu__catalog-title
              | {{content.nav.title}}
            .menu__catalog-items(v-if="content.nav.items")
              .menu__catalog-scroll
                router-link.menu__catalog-item(v-for="item in content.nav.items", :to="item.link", :key="item.id")
                  | {{item.title}}
        .menu__rightBlock
          PreloaderImage
          .menu__left-nav-arrow-mobile.js-mobile-menu-left(v-on:click="leftMenuOpen = !leftMenuOpen")
            SvgIcon.menu__left-nav-arrow-mobile-ico(name="arrow-right-short" width="18" height="18")
          .menu__rightBlock-wr(v-if="contentInside")
            .menu__title(v-if="contentInside.title")
              | {{contentInside.title}}
            form.menu__search(@submit.prevent="search")
              input.menu__search-input(:value="searchStr", type="text", placeholder="Поиск блюда", autocomplete="off", @input='e => searchStr = e.target.value')
              button.menu__search-btn(type="submit")
                SvgIcon.menu__search-btn-ico(name="search", width="24", height="24")
            .menu__cards(v-if="contentInside.items && contentInside.items.length > 0")
              .menu__card(v-for="item in contentInside.items", :key="item.id")
                CardProduct(v-if="item", :cardProduct="item")
            .menu__no-items(v-else) В данной категории блюд нет
            Pagination(v-if="contentInside.pageCount && contentInside.pageCount > 1", :activePage="page", :pageCount="contentInside.pageCount")
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/menu/menu.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {CommonHelpersVue} from '@/mixins/CommonHelpersVue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import Bread from '@/components/common/bread/bread.vue';
  import CardProduct from '@/components/common/cardProduct/cardProduct.vue';
  import Pagination from '@/components/common/pagination/pagination.vue';
  import PreloaderImage from '@/components/common/preloaderImage/preloaderImage.vue';

  export default {
    name: 'Menu',

    mixins: [AjaxHelpersVue, CommonHelpersVue],

    data() {
      return {
        content: null,
        contentInside: null,
        searchStr: '',
        search: null,
        noSearchReq: false,
        page: 1,
        leftMenuOpen: false,
        ps: null
      }
    },

    components: {
      SvgIcon,
      Bread,
      CardProduct,
      Pagination,
      PreloaderImage
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadMenuPage', params => {
        this.request(params.url);
      });

      EventBus.$on('loadMenuPageInside', params => {
        this.$nextTick(() => {
          let searchParams = new URLSearchParams(window.location.search.substring(1));

          if(searchParams.get("page") == null) {
            this.page = 1;
          } else {
            this.page = +searchParams.get("page");
          }

          EventBus.$emit('resetPagination');
          this.searchStr = '';
          this.noSearchReq = true;

          EventBus.$emit('preloaderShow', 'menu');
          this.requestInside();

          setTimeout(() => {
            this.noSearchReq = false;
          }, 500);
        });
      });

      EventBus.$on('setPagination', params => {
        if(params.blockId == 'menu') {
          this.page = params.page;

          this.setPage();
        }
      });

      EventBus.$on('closeMenuLeftEvent', () => {
        this.closeMenuLeft();
      });

      this.search = this.debounce(this.searchRequest, 300);

      this.$nextTick(() => {
        this.setActiveClass();
      });
    },

    watch: {
      searchStr: function() {
        if(!this.noSearchReq) {
          this.search();
        }
      }
    },

    methods: {
      // /menu
      request(url) {
        this.req('MenuPage:getMenuPage', {url}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;

            this.$nextTick(() => {
              let searchParams = new URLSearchParams(window.location.search.substring(1));

              if(searchParams.get("page") == null) {
                this.page = 1;
              } else {
                this.page = +searchParams.get("page");
              }

              EventBus.$emit('resetPagination');
              this.searchStr = '';
              this.noSearchReq = true;

              EventBus.$emit('preloaderShow', 'menu');
              this.requestInside();

              setTimeout(() => {
                this.noSearchReq = false;

                this.scrollInit();
              }, 500);
            });
          }

          this.$nextTick(() => {
            this.setActiveClass();
          });
        }, 'menu');
      },

      requestInside() {
        if(!this.content) {
          this.request('/menyu');
        } else {
          let category = (this.$route.params.category) ? this.$route.params.category : this.content.nav.items[0].link.split('/')[2];

          let params = {
            category: category,
            search: this.searchStr,
            page: this.page
          };

          this.req('MenuPage:getMenuItems', {...params}, res => {
            if(this.checkProperty(res.content)) {
              this.contentInside = res.content;
            }

            this.$nextTick(() => {
              this.setActiveClassInitial();

              setTimeout(() => {
                $('.page__items').css('height', $('.page__item--active').outerHeight(true) + 'px');

                EventBus.$emit('preloaderHide', 'menu');
              }, 500);
            });
          }, '', 'localPageRequest');
        }
      },

      searchRequest() {
        EventBus.$emit('preloaderShow', 'menu');
        EventBus.$emit('resetPagination');
        this.page = 1;

        this.requestInside();
      },

      setPage() {
        EventBus.$emit('preloaderShow', 'menu');
        this.requestInside();
      },

      setActiveClassInitial() {
        let category = this.$route.params.category || '';

        $('.menu__catalog-item').removeClass('menu__catalog-item--active');

        if(category.length) {
          $(`.menu__catalog-item[href*='${category}']`).addClass('menu__catalog-item--active');
        }
        else {
          $('.menu__catalog-item').eq(0).addClass('menu__catalog-item--active');
        }
      },

      setActiveClass() {
        let $items = $('.menu__catalog-item');

        $(document).on('click', '.menu__catalog-item', function() {
          $items.removeClass('menu__catalog-item--active');

          $(this).addClass('menu__catalog-item--active');
        });
      },

      closeMenuLeft() {
        this.leftMenuOpen = false;
      },

      scrollInit() {
        if($(window).width() < 1200) {
          if(this.ps) this.ps.destroy();
          this.ps = new PerfectScrollbar($('.menu__catalog-scroll')[0]);
        }
      }
    }

  }
</script>
